import { JointCommission } from '../../joint-commission/joint-commission.model';
import { Pagination } from '../pagination.model';

export class JointCommissionPage extends Pagination {
  content: JointCommission[] = [];
}
